import { Component, ViewChild, TemplateRef } from '@angular/core';
import { UserService } from '../../../services/user.service';
import { Calculista } from '../../../models/calculista.model';
import { MatDialog } from '@angular/material/dialog';
import { FormService } from 'src/app/services/form.service';
import {  FormBuilder, Validators, FormControl } from '@angular/forms';
import { RutValidator } from 'ng9-rut';
import { NgxSpinnerService } from 'ngx-spinner';
import { startWith, map } from 'rxjs/operators';

declare var jQuery: any;
declare var $: any;
@Component({
    selector: "page-calculista",
    templateUrl: "./calculista.component.html",
    styleUrls: ["./calculista.component.css"],
    providers: [UserService, FormService]
})

export class CalculistaComponent {

    @ViewChild('openModal', { static: true }) openModal:TemplateRef<any>;
    @ViewChild('openModalNODATA', { static: true }) openModalNODATA: TemplateRef<any>;


    public rut_arq;
    public invalidRut: Boolean;
    public calculista: Calculista;
    public rows = [];
    public actualRow;
   
    public filteredOptions;
    public nombreComuna = new FormControl('', [ Validators.required]);
    options = []
    public selectedCal:number = null;

    public matcher = new FormService();

    constructor(private fb: FormBuilder, private _userService: UserService, private rutValidator: RutValidator, 
        private dialog: MatDialog, private spinner: NgxSpinnerService){
        this.rut_arq = this.fb.group({
            rut: ['', [Validators.required, this.rutValidator]]
        })

       
        if(!JSON.parse(localStorage.getItem("calculistas"))){
            localStorage.setItem("calculistas", JSON.stringify(this.rows));
        }else{
            this.rows = JSON.parse(localStorage.getItem("calculistas"));
        }
            this.invalidRut = true;
            this.calculista = {rut: '',nombre:'', mail:'', apellido_mat:'', apellido_pat:'',
            direccion: '', direccion_complemento:'', direccion_num:'', comuna:'', fono:'', fax:'',  patente:'', recordId:''};
    }

    
    ngOnInit() {
        this.getComunas()
        this.filteredOptions = this.nombreComuna.valueChanges
          .pipe(
            startWith(''),
            map(value => this._filter(value))
          );
      }

      private _filter(value: string): string[] {
        const filterValue = value.toLowerCase();
    
        return this.options.filter(option => option.toLowerCase().includes(filterValue));
      }

    get_calculista(rut){
        this.spinner.show();
        this.cleanData();
        this._userService.getCalculista(rut).subscribe(
            response => {
                if(response.message){
                    this.calculista.rut = rut ? rut : '';
                    this.spinner.hide();
                    this.dialog.open(this.openModal);
                } else {
                    this.calculista.rut = response.rut ? response.rut : '';
                    this.calculista.nombre = response.nombre ? response.nombre : '';
                    this.calculista.apellido_mat = response.apellido_mat ? response.apellido_mat : '';
                    this.calculista.apellido_pat = response.apellido_pat ? response.apellido_pat : '';
                    this.calculista.direccion = response.direccion ? response.direccion : '';
                    this.calculista.direccion_complemento = response.direccion_complemento ? response.direccion_complemento : '';
                    this.calculista.direccion_num = response.direccion_num ? response.direccion_num : '';
                    this.calculista.direccion_completa = response.direccion_completa ? response.direccion_completa : '';
                    this.calculista.comuna = response.comuna ? response.comuna : '';
                    this.calculista.fono = response.fono ? response.fono : '';
                    this.calculista.fax = response.fax ? response.fax : '';
                    this.calculista.mail = response.mail ? response.mail : '';
                    this.calculista.patente = response.patente ? response.patente : '';
                    this.calculista.recordId = response.recordId ? response.recordId : '';
                    this.spinner.hide();
                    this.dialog.open(this.openModal);
                }

            },
            error => {
                console.log(error)
            }
        )
    }

    cleanData(){
        this.calculista = {rut: '', nombre:'', mail:'', apellido_mat:'', apellido_pat:'',
            direccion: '', direccion_complemento:'', direccion_num:'', direccion_completa:'', comuna:'', fono:'', fax:'', patente:'', recordId:''};
            this.rut_arq.reset()
    }


    
    update_calculista(rut, id) {
        this.get_calculista(rut);
        this.selectedCal = id;
    }


    savecalculista() {
        window.scroll(0,0);
        //elimina la fila si escriben un rut que ya esté ingresado
        for (let x = 0; x < this.rows.length; x++) {           
            if (this.calculista.rut == this.rows[x].rut) {                
                this.delete_calculista(x);
            }
        }
        
        //elimina fila cuando la editan
        /*if (this.selectedCal != null) {
            this.delete_calculista(this.selectedCal);
            this.selectedCal = null;
        }*/

        this.spinner.show();
        this._userService.saveCalculista(this.calculista).subscribe(
            response => {
                this.spinner.hide();

                console.log(response)
                if(response.update || response.save){
                    $("#arq_modal").modal("hide");
                    this.actualRow = localStorage.getItem("calculistas");
                    this.rows = JSON.parse(this.actualRow);
                    this.rows = this.rows.concat({
                        rut: this.calculista.rut,
                        nombre: this.calculista.nombre,
                        apellido_mat: this.calculista.apellido_mat,
                        apellido_pat: this.calculista.apellido_pat,
                        direccion:this.calculista.direccion,
                        direccion_num:this.calculista.direccion_num,
                        direccion_complemento:this.calculista.direccion_complemento,
                        direccion_completa:this.calculista.direccion_completa,
                        comuna:this.calculista.comuna,
                        fono:this.calculista.fono,
                        fax:this.calculista.fax,
                        mail:this.calculista.mail,
                        patente:this.calculista.patente

                    })
                    localStorage.setItem("calculistas", JSON.stringify(this.rows));
                    this.calculista = {rut: '',nombre:'', mail:'',apellido_mat:'',apellido_pat:'',
                    direccion: '',direccion_complemento:'',direccion_num:'',direccion_completa:'',comuna:'',fono:'', fax:'', patente:'', recordId:''};
                    this.rut_arq.reset()
                    this.dialog.closeAll();
                }
            },
            error => {
                this.spinner.hide();

                console.log(error)
            }
        )
    }
    delete_calculista(id) {
        for (let x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("calculistas", JSON.stringify(this.rows));
                this.rows = JSON.parse(localStorage.getItem('calculistas'));
            }
        }
    }

    getComunas() {

        this._userService.getComunas().subscribe(res => {
            //console.log('res', res);
            for (let i = 0; i < res.length; i++) {
                this.options.push(res[i].fieldData.COM_Nombre)
            }

            this.filteredOptions = this.nombreComuna.valueChanges
                .pipe(
                    startWith(''),
                    map(value => this._filter(value))
                );
        }, error => {
            console.log(error)
        })
    }
}